webpackJsonp([8],{

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Youtube = function (_React$Component) {
  _inherits(Youtube, _React$Component);

  function Youtube() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Youtube);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Youtube.__proto__ || Object.getPrototypeOf(Youtube)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, "state", {
      enumerable: true,
      writable: true,
      value: {
        loaded: false
      }
    }), Object.defineProperty(_this, "handleClick", {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();

        _this.setState({ loaded: true });
      }
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Youtube, [{
    key: "thumbnailURL",
    value: function thumbnailURL() {
      var urlParser = document.createElement("a");
      urlParser.href = this.props.videoEmbedURL;
      var videoID = urlParser.pathname.replace("/embed/", "");

      return "https://i.ytimg.com/vi/" + videoID + "/hqdefault.jpg";
    }
  }, {
    key: "embedURL",
    value: function embedURL() {
      var urlParser = document.createElement("a");
      urlParser.href = this.props.videoEmbedURL;
      urlParser.search = "?autoplay=1&autohide=1&rel=0&showinfo=0"; // for embedding
      urlParser.search += this.props.controls ? "&controls=1" : "&controls=0";
      return urlParser.href;
    }
  }, {
    key: "render",
    value: function render() {
      var notLoaded = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "video-placeholder embed-responsive-item",
          style: { backgroundImage: "url(" + this.thumbnailURL() + ")" },
          title: this.props.alt,
          onClick: this.handleClick },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "play" })
      );
      var loaded = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { frameBorder: "0", src: this.embedURL(), allowFullScreen: this.props.allowFullScreen });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "embed-responsive embed-responsive-16by9" },
        this.state.loaded ? loaded : notLoaded
      );
    }
  }]);

  return Youtube;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(Youtube, "propTypes", {
  enumerable: true,
  writable: true,
  value: {
    videoEmbedURL: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string.isRequired,
    alt: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,
    controls: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.bool,
    allowFullScreen: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.bool
  }
});


/* harmony default export */ __webpack_exports__["a"] = (Youtube);

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_application_Youtube__ = __webpack_require__(149);




document.addEventListener('DOMContentLoaded', function () {
  var elements = document.querySelectorAll('.youtube');
  Array.prototype.forEach.call(elements, function (el, i) {
    // hack for old browsers
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_application_Youtube__["a" /* default */], {
      videoEmbedURL: el.getAttribute('data-url'),
      alt: el.getAttribute('data-alt')
    }), el);
  });
});

/***/ })

},[447]);


// WEBPACK FOOTER //
// youtube-fefb9b3c81d7e49dc37b.js